var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDesktopCurve = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 442,
  height: 894,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#desktop-curve_svg__a)",
  fillRule: "evenodd",
  d: "M442 .5H0v548.578c0 95.248 98.945 172.461 221 172.461S442 798.752 442 894V.5Z",
  clipRule: "evenodd"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#desktop-curve_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.3,
  fillRule: "evenodd",
  d: "M442 0H0v525.891c0 93.09 98.945 168.554 221 168.554S442 769.91 442 863V0Z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "desktop-curve_svg__a",
  x1: 0,
  x2: 442,
  y1: 447.25,
  y2: 447.25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0C71E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00CE81"
})), /*#__PURE__*/React.createElement("filter", {
  id: "desktop-curve_svg__b",
  width: 458,
  height: 879,
  x: -8,
  y: -8,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_4613_104984"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_4613_104984",
  result: "shape"
})))));
export { SvgDesktopCurve as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQyIiBoZWlnaHQ9Ijg5NCIgdmlld0JveD0iMCAwIDQ0MiA4OTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQ0MiAwLjVIMFY1NDkuMDc4QzAgNjQ0LjMyNiA5OC45NDUxIDcyMS41MzkgMjIxIDcyMS41MzlDMzQzLjA1NSA3MjEuNTM5IDQ0MiA3OTguNzUyIDQ0MiA4OTRWNzIxLjUzOVY1NDkuMDc4VjM3Ni42MTdWMC41WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzQ2MTNfMTA0OTg0KSIvPgogICAgPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfYl80NjEzXzEwNDk4NCkiPgogICAgICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNDQyIDBIMFY1MjUuODkxQzAgNjE4Ljk4MSA5OC45NDUxIDY5NC40NDUgMjIxIDY5NC40NDVDMzQzLjA1NSA2OTQuNDQ1IDQ0MiA3NjkuOTEgNDQyIDg2M1Y2OTQuNDQ1VjUyNS44OTFWMzU3LjMzNlYwWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC4zIi8+CiAgICA8L2c+CiAgICA8ZGVmcz4KICAgICAgICA8ZmlsdGVyIGlkPSJmaWx0ZXIwX2JfNDYxM18xMDQ5ODQiIHg9Ii04IiB5PSItOCIgd2lkdGg9IjQ1OCIgaGVpZ2h0PSI4NzkiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KICAgICAgICAgICAgPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KICAgICAgICAgICAgPGZlR2F1c3NpYW5CbHVyIGluPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHN0ZERldmlhdGlvbj0iNCIvPgogICAgICAgICAgICA8ZmVDb21wb3NpdGUgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9ImluIiByZXN1bHQ9ImVmZmVjdDFfYmFja2dyb3VuZEJsdXJfNDYxM18xMDQ5ODQiLz4KICAgICAgICAgICAgPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2JhY2tncm91bmRCbHVyXzQ2MTNfMTA0OTg0IiByZXN1bHQ9InNoYXBlIi8+CiAgICAgICAgPC9maWx0ZXI+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzQ2MTNfMTA0OTg0IiB4MT0iLTMuNzA0ODFlLTA3IiB5MT0iNDQ3LjI1IiB4Mj0iNDQyIiB5Mj0iNDQ3LjI1IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwQzcxRTciLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDBDRTgxIi8+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KPC9zdmc+Cg==";